export default __webpack_public_path__ + "static/media/olivine38.e58fb23a.png";